import { ColDef, ColGroupDef, CsvExportParams, ExcelExportParams } from "ag-grid-community";
import { calculateGP } from "helpers/data/dataHandling";
import { PriceGroupsPriceView } from "models/dbModels/priceGroups/PriceGroupsPrice";

 
export function getPriceGroupEditConfig(editPermission: boolean): (ColDef<PriceGroupsPriceView> | ColGroupDef<PriceGroupsPriceView>)[] | null {        
    return [
        {
            checkboxSelection: true,
            width: 45,
            sortable: false,
            filter: false,
            suppressHeaderMenuButton: true,
        },
        {
            headerName: "Name",            
            flex: 3,
            field: "managedStockName",
            initialSort: "asc",
            suppressHeaderMenuButton: true,
            minWidth: 200,
        },
        {
            headerName: "Cost",
            suppressHeaderMenuButton: true,
            flex: 1,
            field: "managedStockCost",
            cellClass: 'moneyField',
            minWidth: 80,         
            cellRendererSelector: (_) => {
                return { component: "priceCellRenderer" }
        }},
        {
            headerName: "GP%",
            suppressHeaderMenuButton: true,
            width: 85,
            minWidth: 85,
            sortable: false,
            valueGetter: (params) => {
                const sellPrice = params.data?.managedStockBaseSellPrice || 0;
                const costPrice = params.data?.managedStockCost || 0;
                const gstCode = params.data?.managedStockGstCode || 'Y';
                const cal = calculateGP(sellPrice, costPrice, gstCode);
                return cal==undefined? null: cal + "%";
            },
            cellRendererSelector: (_) => {
                return { component: "percentageCellRenderer" }
        }},
        {
            headerName: "Base Sell Price",
            suppressHeaderMenuButton: true,
            flex: 2,
            field: "managedStockBaseSellPrice",
            cellClass: 'moneyField',
            minWidth: 130,
            cellRendererSelector: (_) => {
                return { component: "priceCellRenderer" }
        }},
        {
            headerName: "Current GP%",
            suppressHeaderMenuButton: true,
            flex: 2,
            minWidth: 120,
            sortable: false,           
            valueGetter: (params) => {
                const sellPrice = params.data?.price || 0;
                const costPrice = params.data?.managedStockCost || 0;
                const gstCode = params.data?.managedStockGstCode || 'Y';
                const cal = calculateGP(sellPrice, costPrice, gstCode);
                return cal==undefined? null: cal + "%";
            },
            cellRendererSelector: (_) => {
                return { component: "percentageCellRenderer" }
        }},
        {
            headerName: "Current Sell Price",
            suppressHeaderMenuButton: true,
            flex: 2,
            field: "price",
            cellClass: 'moneyField',
            minWidth: 145,
            cellRendererSelector: (_) => {
                return { component: "priceCellRenderer" }
        }},
        {
            headerName: "New GP%", 
            suppressHeaderMenuButton: true,          
            flex: 2,
            minWidth: 100,
            sortable: false,
            valueGetter: (params) => {
                const sellPrice = params.data?.newPrice || 0;
                const costPrice = params.data?.managedStockCost || 0;
                const gstCode = params.data?.managedStockGstCode || 'Y';
                const cal = calculateGP(sellPrice, costPrice, gstCode);
                return cal==undefined? null: cal + "%";
            },
            cellRendererSelector: (_) => {
                return { component: "percentageCellRenderer" }
            },
        },
        {
            headerName: "New Sell Price",
            suppressHeaderMenuButton: true,
            field: "newPrice",
            flex: 2,
            minWidth: 180,
            editable: editPermission,     
            cellClass: 'cursor-text moneyField',
            valueSetter: (params) => {
				params.data.newPrice = params.newValue;
				return true;
            },
            cellEditor: 'moneyCellEditor',
           
            cellRendererSelector: (_) => {
                return { component: "editablePriceCellRenderer" }
            }
        },
        {
            headerName: "Last Applied",
            suppressHeaderMenuButton: true,
            field: "applied",
            flex: 3,
            valueGetter: (params) => params.data?.applied != null? new Date(params.data?.applied).toLocaleString('en-au',{ hour12: true })
                .replace(",","").toUpperCase(): null          
        }
    ];
}

export function getEditPriceGroupkCsvDataFormatter(): CsvExportParams{
    return {
        fileName: "ManagedStock_" + new Date().toLocaleDateString('en-AU', {
            day : 'numeric',
            month : 'short',
            year : 'numeric',
            hour : '2-digit',
            minute : '2-digit'
        }).split(' ').join('-').replace(',', '') +".csv",

        processCellCallback: (cell) => {
            if (["3","4","5"].includes(cell.column.getColId()) && cell.value != null) {
             
                return `${cell.value}` + "%";
              }
              if (cell.column.getColId() === 'applied' && cell.value != null) {
                return (cell.value as String).split(' ')[0];
              }
              return cell.value;
        },
    }
}

export function getEditPriceGroupDataFormatter(): ExcelExportParams {
    return {
        processCellCallback: (cell) => {
              if (cell.column.getColId() === 'applied' && cell.value != null) {
                return (cell.value as String).split(' ')[0];
              }
              return cell.value;
        },
        sheetName: "Price Group"
    }
}